// extracted by mini-css-extract-plugin
export var clauseRow = "_ft-6";
export var emptyState = "_ft-d";
export var filterContent = "_ft-a";
export var filterGroup = "_ft-1";
export var filterGroupContainer = "_ft-0";
export var nestedGroup = "_ft-2";
export var nestedGroupContent = "_ft-b";
export var nestedGroupDepth1 = "_ft-3";
export var nestedGroupDepth2 = "_ft-4";
export var nestedGroupDepth3 = "_ft-5";
export var nestedGroupEmpty = "_ft-c";
export var operatorAnd = "_ft-8";
export var operatorOr = "_ft-9";
export var operatorToggle = "_ft-7";
export var removeGroupButton = "_ft-e";